// src/api/battleApi.js
import apiClient from "./apiClient";

// 🔹 대결 리스트 조회
// filters: { searchKeyword, searchStartDate, modeFilter, statusFilter, genderType }
export const listBattle = (filters) => {
  return apiClient.get("/battle/listBattle", {
    params: {
      searchKeyword: filters.searchKeyword || "",
      searchStartDate: filters.searchStartDate || "",
      statusFilter:
        filters.statusFilter === "" || filters.statusFilter == null
          ? null
          : filters.statusFilter,
      modeFilter:
        filters.modeFilter === "" || filters.modeFilter == null
          ? null
          : filters.modeFilter,
      genderType:
        filters.genderType === "" || filters.genderType == null
          ? null
          : filters.genderType,

          userLat: filters.userLat ?? null,
      userLng: filters.userLng ?? null,

      
      // ✅ 최소 수정: 페이징 + 로그인 사용자
      offset: filters.offset ?? 0,
      limit: filters.limit ?? 5,
      userId: filters.userId ?? null,


    },
  });
};


// src/api/battleApi.js
export const startBattle = (battleId, userId) =>
  apiClient.post(`/battle/startBattle`, { battleId, userId });

// 🔹 대결 상세
export const getBattle = (battleId) =>
  apiClient.get("/battle/getBattle", { params: { battleId } });

// 🔹 대결 생성
export const addBattle = (data) =>
  apiClient.post("/battle/addBattle", data);

// 🔹 대결의 전당 / Top 리스트
export const topBattle = (params) =>
  apiClient.get("/battle/topBattle", { params });

// 🔹 내 대결 리스트
export const listMyBattle = (params) =>
  apiClient.get("/battle/listMyBattle", { params });

// 🔹 대결 참가
export const joinBattle = ({ battleId, userId, team }) =>
  apiClient.post("/battle/joinBattle", {
    battleId,
    userId,
    team,
  });

// 🔹 대결 결과 리스트 (JoinBattle + Users + WorkRecord)
export const getBattleResultList = (battleId) =>
  apiClient.get("/battle/result", {
    params: { battleId },
  });

// 🔹 대결 종료(결과 계산)
export const finishBattle = (battleId, workRecordId) =>
  apiClient.post(`/battle/${battleId}/finish`, null, {
    params: { workRecordId },
  });




// 🔹 성별별 TOP10
export const getTopBattleByGender = async (genderType) => {
  const res = await apiClient.get("/battle/topBattle", {
    params: { genderType },
  });
  return res.data;
};
